


































































































import Vue from "vue";
import uploader from '../../common/components/uploader.vue';
import {WorkRecordServiceProxy,WorkRecordSettingServiceProxy} from "@/service-proxies/app-v2/work-record.service-proxies";
import moment from 'moment';
import { DictBizServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
const workRecordService = new WorkRecordServiceProxy();
const workRecordSettingServiceProxy = new WorkRecordSettingServiceProxy();
const dictBizService = new DictBizServiceProxy();

export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {uploader},
  data() {
    return {
      rules: {
        comment: [
          { required: true, message: this.$t('page_ops_work_record_hanlde_required'), trigger: "change" },
        ],
        jobType: [
          { required: true, message: `${this.$t('please_select')}${this.$t('page_ops_work_record_job_classification')}`, trigger: "change" },
        ],
        industryType: [
          { required: true, message: `${this.$t('please_select')}${this.$t('page_ops_work_record_industry_classification')}`, trigger: "change" },
        ],
        checkedlist: [
          {
            type: "array",
            required: true,
            message: this.$t('page_ops_work_record_audit_person_required'),
            trigger: "change",
          },
        ],
      },
      form: {
        comment: "",
        time: [],
        timeConsuming: "",
        checkedlist: [],
        jobType: undefined,
        industryType: undefined,
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      taskId: "",
      workRecordId: "",
      customerId: "",
      processProgress: "",
      userOptions: [],
      imageList: [],
      videoList: [],
      jobTypeList: [],
      industryTypeList: []
    };
  },
  methods: {
    async initData(record) {
      this.taskId = record.currentTaskId;
      this.workRecordId = record.id;
      this.customerId = record.customerId;
      this.processProgress = record.processProgress;

      let res = await workRecordSettingServiceProxy.getAuditUsers(
        this.workRecordId
      );
      this.userOptions = res.users.map((item) => {
        return { label: item.name, value: item.id };
      });
      // 默认选择指派人员
      this.form.checkedlist = res.assignedUsers;

      workRecordService.getWorkRecordHandleDetail(record.id).then(res=>{
        this.form.time = [moment(res.startTime), moment(res.endTime) ];
        this.onChange(this.form.time);
        this.form.jobType = res.jobType;
        this.form.industryType = res.industryType;
      })
      dictBizService.dictionary("job-type").then(res=>{
          this.jobTypeList = res.data;
      })
      dictBizService.dictionary("industry-type").then(res=>{
          this.industryTypeList = res.data;
      })
    },
    getImageList(data){
      this.imageList = data
    },
    getVideoList(data){
      this.videoList = data
    },
    onChange(date) {
      const hour = ((new Date(date[1]).getTime() - new Date(date[0]).getTime())/( 60 * 60 * 1000)).toFixed(2)
      this.form.timeConsuming = hour
    },
    save() {
      this.$refs.handleForm.validate((valid) => {
        if (valid) {
          const {time} = this.form;
          if(time){
            this.form.startTime = time[0];
            this.form.endTime = time[1];
          }
          const params: any = {
            comments: this.form.comment,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            timeConsuming: this.form.timeConsuming,
            jobType: this.form.jobType,
            industryType: this.form.industryType,
            processProgress: this.processProgress,
            processUserIds: this.form.checkedlist,
            taskId: this.taskId,
            workRecordId: this.workRecordId,
            attachmentList: [...this.imageList,...this.videoList]
          };

          workRecordService.processWorkRecord(params).then((res) => {
            this.reset();
            this.$message.success(this.$t("success"));
            this.$emit("cancel", true);
          });
        }
      });
    },
    reset() {
      this.form.checkedlist = [];
      this.form.comment = "";
      this.form.time = [];
      this.form.timeConsuming = "";
      this.form.jobType = "";
      this.form.industryType = "";
      this.imageList= [];
      this.videoList= [];
    },
    changeJobType(value) {
      this.form.jobType = value;
    },
    changeIndustryType(value) {
      this.form.industryType = value;
    },
  },
});
